import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export const Sunrise25UsersColumns = [
  {
    id: 'firstName',
    disablePadding: true,
    label: 'First Name',
  },
  {
    id: 'lastName',
    disablePadding: true,
    label: 'Last Name',
  },
  {
    id: 'enrollmentDate',
    disablePadding: true,
    label: 'Enrollment Date',
  },
  {
    id: 'location',
    disablePadding: true,
    label: 'Location',
  },
  {
    id: 'countryName',
    disablePadding: false,
    label: 'Country Name',
  },
];

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const Sunrise25UserTableColumns = ({ order, orderBy, onRequestSort }) => {
  return (
    <Fragment>
      <TableRow>
        {Sunrise25UsersColumns.map((row) => (
          <TableCell
            className="material-table__cell material-table__cell--sort material-table__cell-center"
            key={row.id}
            align={'center'}
            padding={row.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === row.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order}
              onClick={createSortHandler(row.id, onRequestSort)}
              className="material-table__sort-label"
              dir="ltr"
            >
              <b>{row.label}</b>
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </Fragment>
  );
};

Sunrise25UserTableColumns.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default Sunrise25UserTableColumns;
